import React, { useEffect, useRef } from "react";
import { useLanguage } from "../../context/LanguageContext";

const Captcha = ({ onTokenReceived, isMobile }) => {
  const { language } = useLanguage();
  const captchaRef = useRef(null);
  const isInitializedRef = useRef(false);
  const scriptLoadedRef = useRef(false);
  let isCaptchaPassed = false;
  const siteRef = useRef(isMobile ? "h5" : "pc");

  function initCollapseMotion() {
    // 防止重复初始化
    if (isInitializedRef.current) {
      return;
    }
    
    // 清理之前的实例
    if (captchaRef.current && captchaRef.current.clear) {
      captchaRef.current.clear();
    }
    siteRef.current = isMobile ? "h5" : "pc";
    captchaRef.current = new window["jigsawVerification_v1"]({
      appId: 100017154,
      businessSite: isMobile ? "infosec_sso_login_h5_pic" : "infosec_sso_login_online_pic",
      id:  'infosec-login-captcha',
      mode: "popup",
      width: "280px",
      language: language === 'CN' ? 'zh-CN' : 'en-US', // 滑块验证码语种
      site: "ctrip",
      hideClose: true,
      // 状态监听函数
      stateChange: function (state) {
        if (state == 0) {
          if ("undefined" !== typeof console) {
            console.log("拼图显示 state:", state);
          }
        } else if (state == 1) {
          if ("undefined" !== typeof console) {
            console.log("选图标验证码出现 state:", state);
          }
        }
      },
      // 拼图错误后调用的函数
      onJigsawFail: function () {
        // console.log("fail");
      },
      // 选图标错误后调用的函数
      onSelectFail: function () {
        // console.log("select fail");
      },
      onClose: function () {
        if(!isCaptchaPassed){
            isInitializedRef.current = false;
            initCollapseMotion();
        }
      },
      // 风险检测结果
      resultHandler: function (e) {
        if (e.checkState === "success" || e.checkState === "hidden") {
            isCaptchaPassed = true;
          onTokenReceived && onTokenReceived({token: e.token, version: e.version, site: siteRef.current});
        }
      },
    });
    isInitializedRef.current = true;
  }

  useEffect(() => {
    // 防止重复执行
    if (isInitializedRef.current) {
      return;
    }
    const loadCaptcha = () => {
      if (window["jigsawVerification_v1"]) {
        // 如果脚本已加载，直接初始化验证码
        initCollapseMotion();
      } else {
        // 检查是否已经有脚本正在加载
        if (scriptLoadedRef.current) {
          return;
        }
        
        // 检查是否已经有相同的脚本标签
        const existingScript = document.querySelector('script[src*="jigsaw-captcha-module.min.js"]');
        if (existingScript) {
          // 如果脚本已经存在，等待加载完成
          existingScript.onload = () => {
            if (window["jigsawVerification_v1"]) {
              initCollapseMotion();
            }
          };
          return;
        }
        
        // 标记脚本正在加载
        scriptLoadedRef.current = true;
        
        // 如果脚本未加载，动态加载脚本
        const script = document.createElement("script");
        script.src =
          "https://static.tripcdn.com/packages/infosec/jigsaw-captcha/~1.0.0/static/js/jigsaw-captcha-module.min.js";
        script.onload = () => {
          initCollapseMotion();
        };
        script.onerror = () => {
          console.error("验证码脚本加载失败");
          scriptLoadedRef.current = false; // 重置加载状态
        };
        document.head.appendChild(script);
      }
    };
    
    loadCaptcha();
    
    // 清理函数
    return () => {
      if (captchaRef.current && captchaRef.current.clear) {
        captchaRef.current.clear();
      }
      isInitializedRef.current = false;
    };
  }, [language, isMobile]);

  return <div id="infosec-login-captcha"></div>;
};

export default Captcha;
